module.exports = __webpack_public_path__ + "static/img/fu2.2c7f7fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu2.jpg
// module id = g/cm
// module chunks = 1